<script lang="ts">
  import { fly } from "svelte/transition";
import { is_typing } from "../stores";
  // import { User } from "../../../server/interfaces";
  // import { messages } from "../stores";
  export let messages: Array<{
    user: any;
    content: string;
    time: number;
    spectator: boolean;
  }>;
  export let send_func: (content: string) => void;

  export let h: number, w: number, m: number;

  let message: string;
  let bottom: HTMLSpanElement;

  $: {
    messages;
    if (bottom) {
      setTimeout(() => {
        bottom.scrollIntoView({ behavior: "smooth" });
      }, 105);
    }
  }

  const handleKeyup = (event: { code: any; target: any }) => {
    if (
      event.target.value &&
      event.code == "Enter" &&
      event.target.value !== ""
    ) {
      // messages = messages.concat([event.target.value]));
      send_func(event.target.value);
      message = "";
      // setTimeout(() => {
      //   bottom.scrollIntoView({ behavior: "smooth" });
      // }, 105);
    }
  };
</script>

<div
  class="chat no-scroll"
  style={`width: ${w}px; height: ${h}px; margin: ${m}px`}
>
  <div class="messages no-scroll">
    {#each messages as { user, content, time, spectator }}
      {#if user.id === "1"}
        <div in:fly={{ y: 100, duration: 100 }} class="server">
          {content}
        </div>
      {:else}
        <div in:fly={{ y: 100, duration: 100 }} class="msg">
          <div class="identity">
            <div class="personal">
              <img
                class="avatar"
                src={user.icon}
                alt={user.name}
                draggable="false"
              />
              <h2 class="name">{`${user.name}#${user.discriminator}`}</h2>
              {#if spectator}
                <i class="fas fa-eye" />
              {/if}
            </div>
            <h1 class="time">{new Date(time).toLocaleTimeString()}</h1>
          </div>
          <div class="content">
            {content}
          </div>
        </div>
      {/if}
    {/each}
    <span class="bottom" bind:this={bottom} />
  </div>
  <div class="actions">
    <input
      id="input_box"
      class="textbox"
      placeholder="your message..."
      on:keyup|preventDefault={handleKeyup}
      bind:value={message}
      on:focus={()=>is_typing.set(true)}
      on:blur={()=>is_typing.set(false)}
    />
    <button
      class="send"
      on:click={() => {
        handleKeyup({ code: "Enter", target: { value: message } });
      }}
      disabled={!message || message === ""}
    >
      <i class="fas fa-paper-plane " />
    </button>
  </div>
</div>

<style>
  .actions {
    height: 10%;
    display: flex;
    margin: 0.5rem;
  }

  .chat {
    background-color: var(--accent-color);
    box-shadow: 0px 0px 10px 2px var(--accent-color-shadow);
    color: var(--text-color);
    border-radius: 5px;
    /* overflow-y: hidden; */
  }

  .messages {
    height: 85%;
    overflow-y: scroll;
  }

  .send {
    width: 15%;
    padding: 0;
    margin: 0;
    margin-left: 0.5rem;
    cursor: pointer;
  }

  .textbox {
    width: 85%;
    margin: 0;
    outline: none;
    background-color: var(--accent-color-hover);
    border-radius: 5px;
  }

  .msg {
    /* padding: 1rem 2rem; */
    text-align: left;
    transition: all 100ms;
    background-color: var(--accent-color);
    margin: 0.5rem 0.5rem;
    border-radius: 5px;
  }

  .msg:hover {
    background-color: var(--accent-color-hover);
    box-shadow: 0px 0px 10px 1px var(--accent-color-shadow);
  }

  .identity {
    display: flex;
    align-items: center;
    text-align: left;
    justify-content: space-between;
  }

  .personal {
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .time {
    font-size: 0.7rem;
    margin-right: 0.2rem;
    color: var(--text-color-secondary);
    user-select: none;
  }

  .avatar {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    overflow: hidden;
    background-color: rgb(23, 23, 23);
    margin: 0.5rem;
    user-select: none;
  }

  .name {
    font-size: 0.8rem;
    color: var(--text-color-secondary);
  }

  .fa-eye {
    padding-left: 1rem;
    font-size: 0.8rem;
    color: var(--text-color-secondary);
  }

  .content {
    padding: 0 0.5rem 0.5rem 0.5rem;
  }

  .server {
    font-size: 0.8rem;
    color: var(--text-color-secondary);
    margin: 0.5rem 0.5rem;
  }
</style>
